"use client"

import { GitProvider } from "@/pb/api/devplan/types/integrations"
import {IconBitBucket, IconGitLab, IconGithub} from "../icons/Icons"

export function GitProviderIcon({provider, className}: { provider: GitProvider, className?: string }) {
  switch (provider) {
    case GitProvider.BIT_BUCKET:
      return <IconBitBucket className={className}/>
    case GitProvider.GITHUB:
      return <IconGithub className={className}/>
    case GitProvider.GITLAB:
      return <IconGitLab className={className}/>
  }
  return null
}
